define('phoneUtils',['libphonenumber','underscore','string','app'],function(libPhoneNumber,_,S,app){

    // private instance
    var instance,
        _DEFAULT_COUNTRY_PHONE_ = '_DEFAULT_COUNTRY_PHONE_',
        AsYouTypeFormatter = libPhoneNumber.AsYouTypeFormatter,
        FORMAT_E164 = libPhoneNumber.PhoneNumberFormat.E164,
        FORMAT_NATIONAL = libPhoneNumber.PhoneNumberFormat.NATIONAL,
        FORMAT_INTERNATIONAL = libPhoneNumber.PhoneNumberFormat.INTERNATIONAL;


    function getInstance(){
        return instance = instance || libPhoneNumber.PhoneNumberUtil.getInstance();
    }

    var phoneUtils = {
        validate:function(phone,countryCode,fail,success){
            //
            // validate phone number,
            // return false & fail callback on failure
            // return phone formatted E164 on success & success callback
            //
            try{
                instance = getInstance();
                //
                var defaultCountryCode = countryCode || app.c(_DEFAULT_COUNTRY_PHONE_, 'FR'),
                    phoneParsing = instance.parseAndKeepRawInput(phone, defaultCountryCode),
                    callback,
                    validation,
                    formatted,
                    phoneCountryCode = phoneUtils.getRegionCodeForNumber(phone,countryCode),
                    E164 = instance.format(phoneParsing,FORMAT_E164);

                validation = instance.isValidNumber(phoneParsing)
                if(!validation){
                    if(phoneCountryCode){
                        phoneParsing = instance.parseAndKeepRawInput(phone, phoneCountryCode);
                        validation = instance.isValidNumber(phoneParsing);
                    }
                }
                formatted = validation ? E164 : validation;
                callback = validation ? success : fail;

                //
                if(callback && _.isFunction(callback)){
                    callback(formatted);
                }
                return formatted;
            }catch(err){
                if(fail && _.isFunction(fail)){
                    fail(err);
                }
                return false;
            }

        },
        format:function(phone,countryCode,format){
           format = format || FORMAT_E164;
            // formate un numéro dans son format national.
            getInstance();
            var output = phone;
            countryCode = countryCode || app.c(_DEFAULT_COUNTRY_PHONE_, 'FR');
            try{
                var phoneParsing = instance.parseAndKeepRawInput(phone, countryCode);
                output = instance.format(phoneParsing, format);
            }catch(err){
            }
            return output;
        },
        formatNational:function(phone,countryCode){
            // formate un numéro dans son format national.
            return phoneUtils.format(phone,countryCode,FORMAT_NATIONAL);
        },
        formatInternational:function(phone,countryCode){
            // formate un numéro dans son format national.
            return phoneUtils.format(phone,countryCode,FORMAT_INTERNATIONAL);
        },
        inspectPhoneNumber:function(phone,countryCode){
            getInstance();
            var formatted = phone,
                E164 = false,
                isPossibleNumber = false,
                success = false,
                phoneParsing,
                phoneCountryCode,
                output = {};
            try{
                phoneParsing = instance.parseAndKeepRawInput(phone, countryCode);
                isPossibleNumber = instance.isPossibleNumber(phoneParsing);
                phoneCountryCode = instance.getRegionCodeForNumber(phoneParsing);
                if(phoneCountryCode !== countryCode) {
                    // si le pays ne correspond pas, on ne formate pas.
                }else if(isPossibleNumber){
                    formatted = instance.format(phoneParsing, FORMAT_NATIONAL);//formatInOriginalFormat(phoneParsing,countryCode);
                    success = true;
                }
                E164 = instance.format(phoneParsing, FORMAT_E164);//formatInOriginalFormat(phoneParsing,countryCode);
            }catch(err){
                // on error return the original format
            }
            output.formatted = formatted;
            output.E164 = E164;
            output.success = success;
            output.phoneParsing = phoneParsing;
            output.isPossibleNumber = isPossibleNumber;
            output.phoneCountryCode = phoneCountryCode;
            return output;
        },
        getRegionCodeForNumber:function(phone,countryCode){
            instance = getInstance();
            countryCode = countryCode || app.c(_DEFAULT_COUNTRY_PHONE_, 'FR');
            var regionCode;
            try{
                var phoneParsing = instance.parseAndKeepRawInput(phone,countryCode);
                regionCode = instance.getRegionCodeForNumber(phoneParsing);
            }catch(err){
                // on va utiliser le pays par défaut en cas d'erreur
                regionCode = countryCode
            }
            return regionCode;
        },
        getCodeForRegion:function(countryCode){
            var prefix = [];
            _.each(libPhoneNumber.metadata.countryCodeToRegionCodeMap,function(codeArray,index){
                  if(_.contains(codeArray,countryCode)){
                      prefix.push(index);
                  }
            });
            return prefix[0];
        },
        getSupportedRegions:function(){
            getInstance();
            var countryList,
                regions = instance.getSupportedRegions(),
                countryShortList = app.c('_PHONE_COUNTRY_SHORT_LIST_','').split(',');
            ;
            countryList = _.map(regions,function(countryCode){
                var country = app.getCountryByIsoCode(countryCode),
                    countryName = country ? country.getName() : countryCode,
                    shortListed = _(countryShortList).contains(countryCode),
                    emoji;
                try{
                    // converti un code iso en EMOJI pays
                    emoji = app.isMobile() ? countryCode.toUpperCase().replace(/./g, function(char){return String.fromCodePoint(char.charCodeAt(0)+127397)} ):'';
                }catch(err){
                    emoji = '';
                }
                return {
                    _s:(shortListed?'0':'1')+countryName,
                    country:country?true:false,
                    emoji:emoji,
                    shortListed:shortListed,
                    name:countryName,
                    code:countryCode
                }
            });
            countryList = _.sortBy(countryList,'_s');
            return countryList;

        }
    };
    return phoneUtils;

});
